module.exports = __webpack_public_path__ + "static/Product_Logo_PlayStore-4c7246fd6b7a9e7cf02853c375699605.png";